import { ProviderFormProvider } from '@pages/Fabric/common/ProviderFormContext';
import { UnifiedDatabricksForm } from '@pages/Fabric/unifiedFabrics/databricks/UnifiedDatabricksForm';

import { DatabricksReadOnlyView } from './DatabricksReadOnlyView';

export const DatabricksSetupForm = ({ isReadonly }: { isReadonly: boolean }) => {
  if (isReadonly) {
    return <DatabricksReadOnlyView />;
  }

  return (
    <ProviderFormProvider isOrchestrationFabric={false}>
      <UnifiedDatabricksForm />
    </ProviderFormProvider>
  );
};
